/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Cookies } from 'react-cookie';
import * as luxon from 'luxon';
import { logout } from 'blb-api/auth';
export const cookies = new Cookies();
export const getSignedJSONCookie = stringifiedCookieWithSignature => {
  const challengeCookieNotParsed = stringifiedCookieWithSignature.slice(2, stringifiedCookieWithSignature.indexOf(`}.`) + 1);
  const parsedCookie = JSON.parse(challengeCookieNotParsed);
  return parsedCookie;
};
export const getParsedCookieValue = cookieName => {
  const cookie = cookies.get(cookieName);
  const parsedCookie = cookie && cookie.slice(2, cookie.indexOf('.'));
  return parsedCookie;
};
export const removeCookie = cookieName => {
  cookies.remove(cookieName);
};
export const parseLastActivityCookie = () => {
  const parsedCookie = getParsedCookieValue('last_activity');
  const timestamp = Number(parsedCookie);
  const isInvalidCookie = !parsedCookie || !luxon.DateTime.fromMillis(timestamp).isValid;
  if (isInvalidCookie) {
    logout();
    return undefined;
  }
  return timestamp;
};